import { createFileRoute, redirect } from '@tanstack/react-router';

// Links from the short-lived per-number pages: the number now opens in place
// on the Numbers tab.
export const Route = createFileRoute(
  '/_dashboard/dashboard/settings/call-settings/numbers/$numberId',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/settings/call-settings',
      search: { tab: 'numbers', number: params.numberId },
    });
  },
});
